import React, { useEffect, useState } from "react";
import { FaSearch } from "react-icons/fa"; // Import the search icon
import { useSearchParams } from "react-router-dom";

const SearchBar = ({ placeholder, onSearch, value, persistToUrl = true, paramKey = "search" }) => {
  const [query, setQuery] = useState(value || ""); // Initialize with value prop
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    setQuery(value || ""); // Sync with external value changes
  }, [value]);

  // Initialize from URL on mount
  useEffect(() => {
    if (!persistToUrl) return;
    const existing = searchParams.get(paramKey);
    if (existing && existing !== query) {
      setQuery(existing);
      onSearch?.(existing);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInputChange = (e) => {
    setQuery(e.target.value);
    onSearch(e.target.value);
    if (persistToUrl) {
      const next = new URLSearchParams(searchParams.toString());
      if (e.target.value && e.target.value.length > 0) {
        next.set(paramKey, e.target.value);
      } else {
        next.delete(paramKey);
      }
      setSearchParams(next);
    }
  };

  return (
    <div className="w-full">
      <div className="relative">
        <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
        <input
          type="text"
          value={query}
          onChange={handleInputChange}
          placeholder={placeholder}
          className="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary transition-all duration-200 h-10"
        />
      </div>
    </div>
  );
};

export default SearchBar;
